import { useState } from 'react';
import { Flex, Box, TextField, Icon, IconButton } from '@vibe/core';
import { HighlightColorBucket, Bullet, LearnMore } from '@vibe/icons';
import { ChromePicker } from 'react-color';

type ColorSettingProps = {
  title: string;
  value: string;
  onChange: (newValue: string) => void;
  setHelpState: any;
  settingCategory: string;
  setShowHelpModal: any;
};

export function ColorSetting({ title, value, onChange, setHelpState, settingCategory, setShowHelpModal }: ColorSettingProps) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  return (
    <Box className="CustomBox">
      <Flex gap={0} direction="column" align="start">
        <label style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <small>{title}</small>
          <IconButton
            className="CustomHelpButton"
            icon={LearnMore}
            kind="tertiary"
            size="xxs"
            onClick={() => {
              setHelpState({ category: settingCategory, content: title.toLowerCase().replace(/[^a-z]/g, '_') });
              setShowHelpModal(true);
            }}
          />
        </label>
        <div style={{ position: 'relative', width: '100%' }}>
          <TextField
            wrapperClassName="CustomColorPickerInput"
            className="CustomInput"
            //title={(<small>{title}</small>) as any}
            icon={HighlightColorBucket}
            size="medium"
            maxLength={7}
            value={value}
            onBlur={(ev) => {
              // @ts-ignore-next-line
              onChange(ev.target.value as any);
            }}
            onIconClick={() => {
              setDisplayColorPicker(!displayColorPicker);
            }}
          />
          <div style={{ pointerEvents: 'none', position: 'absolute', top: '5px', left: 0, color: value }}>
            <Icon icon={Bullet} size={30} />
          </div>

          {displayColorPicker ? (
            <div
              style={{
                zIndex: '2',
                position: 'absolute',
                top: '29px',
              }}
            >
              <div
                style={{
                  position: 'fixed',
                  top: '0px',
                  right: '0px',
                  bottom: '0px',
                  left: '0px',
                }}
                onClick={() => {
                  setDisplayColorPicker(false);
                }}
              />
              {/* React 19 ignores defaultProps on function components, which drops the picker's 225px default width */}
              <ChromePicker
                styles={{ default: { picker: { width: '225px' } } }}
                disableAlpha
                color={value}
                onChangeComplete={(newColor) => {
                  onChange(newColor.hex);
                }}
              />
            </div>
          ) : null}
        </div>
      </Flex>
    </Box>
  );
}
